var _path, _path2, _path3, _path4, _linearGradient, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024.9 1024.9",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M873.5 148.2C789.6 65 682 14.2 566 2.2c-28.6-3-53.6 19.3-53.6 48.1 0 24.8 18.7 45.5 43.3 48.1 209 21.7 372.4 198.9 372.4 413.5 0 229-186.8 415.8-415.8 415.8-229.3 0-415.8-186.5-415.8-415.8 0-20.5 1.5-40.7 4.4-60.4 4.3-29.3-18.2-55.6-47.8-55.6-24 0-44.4 17.6-47.9 41.4-3.5 24.3-5.3 49-5.4 74-.1 130.4 49.5 256.4 138.8 351.4 97.9 104.1 231.4 161.7 373.6 161.7 136 0 266.1-53.9 362.3-150 98.9-98.8 152.4-230.9 150.1-371.1-1.9-133.4-56.5-261.1-151.1-355.1",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M515.2 1024.9c118.2-.4 230.1-40.6 320.6-114.2 22.3-18.1 24.2-51.5 3.9-71.9-17.5-17.5-45.4-19-64.6-3.4-163.1 132.4-404 122.7-555.8-29.1-161.9-161.9-161.9-426.1 0-588 162.1-162.1 425.9-162.1 588 0 14.5 14.5 27.7 29.8 39.6 45.8 17.7 23.7 52.2 26.4 73.1 5.5 17-17 19-43.9 4.6-63.2q-22.05-29.55-48.6-56.1C784 58.2 659.8 4.2 529.5.2 386.6-4.1 251.6 49.5 151 150.1 54.8 246.2.9 376.3.9 512.3c0 139.8 55.5 271.1 156.2 368.5 95.9 92.9 224.7 144.6 358.1 144.1",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M873.5 148.2C789.6 65 682 14.2 566 2.2c-28.6-3-53.6 19.3-53.6 48.1 0 24.8 18.7 45.5 43.3 48.1 209 21.7 372.4 198.9 372.4 413.5 0 229-186.8 415.8-415.8 415.8-229.3 0-415.8-186.5-415.8-415.8 0-20.5 1.5-40.7 4.4-60.4 4.3-29.3-18.2-55.6-47.8-55.6-24 0-44.4 17.6-47.9 41.4-3.5 24.3-5.3 49-5.4 74-.1 130.4 49.5 256.4 138.8 351.4 97.9 104.1 231.4 161.7 373.6 161.7 136 0 266.1-53.9 362.3-150 98.9-98.8 152.4-230.9 150.1-371.1-1.9-133.4-56.5-261.1-151.1-355.1",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M512.5 859c-92.7 0-179.8-36.1-245.4-101.6-65.5-65.5-101.6-152.7-101.6-245.4s36.1-179.8 101.6-245.4S419.8 165 512.5 165s179.8 36.1 245.4 101.6c65.5 65.5 101.6 152.7 101.6 245.4s-36.1 179.8-101.6 245.4C692.3 822.9 605.2 859 512.5 859m0-597.4c-138 0-250.4 112.3-250.4 250.4s112.3 250.4 250.4 250.4S762.8 650 762.8 511.9 650.5 261.6 512.5 261.6",
    className: "st0"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 512.455,
    x2: 512.455,
    y1: 694.633,
    y2: 329.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0512a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f7e21a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512.5,
    cy: 511.9,
    r: 182.7,
    fill: "url(#a)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export default ForwardRef;